import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {EventGroupComponent} from './event-group.component';
import {EventGroupResolver} from './resolvers/event-group.resolver'
import { CartResetTimeoutResolver } from '@biletix/core/resolvers/cart-reset-timeout.resolver';

const routes: Routes = [
  {
    path: '',
    component: EventGroupComponent,
    resolve: {
      eventDetail: EventGroupResolver,
      cartTimeout: CartResetTimeoutResolver
    }
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EventGroupRoutingModule {
}
